import { getArchive, restoreFromArchive } from '../actions';
import { ArchiveNode, Statuses } from '../admin-knowledge-base.type';
import { useCallback, useEffect, useState } from 'react';

export const useDeletedEntities = () => {
    const [items, setItems] = useState<ArchiveNode[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchArchive = useCallback(async () => getArchive().then(setItems), []);

    useEffect(() => {
        fetchArchive();
    }, [fetchArchive]);

    const restore = useCallback(async (id: string, status: Statuses) => {
        try {
            setIsLoading(true);
            await restoreFromArchive(id, status);
            setItems((prev) => prev.filter((item) => item.key !== id));
        } finally {
            setIsLoading(false);
        }
    }, []);

    return { items, isLoading, restore, refetch: fetchArchive };
};
